import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DashboardResponse, PayloadParam } from '@core/interface/dashboard';
import { EpDashboardResponse } from '@core/interface/ep-dashboard';

import { environment } from '@environment/environment';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  constructor(private http: HttpClient) {}

  getDashboardData(param: PayloadParam) {
    let httpParams = new HttpParams();
    if (param)
      Object.keys(param).forEach((key) => {
        httpParams = httpParams.set(
          key,
          (param[key as keyof PayloadParam] as any) || ''
        );
      });
    return this.http.get<DashboardResponse>(environment.endPoints.dashboard, {
      params: httpParams,
    });
  }

  getEpDashboard(param: {
    start_date: string;
    end_date: string;
    user_id?: string;
  }) {
    let httpParams = new HttpParams();
    Object.entries(param).forEach(([key, value]) => {
      if (value) {
        httpParams = httpParams.set(key, value);
      }
    });
    return this.http.get<EpDashboardResponse>(environment.endPoints.epDashboard, {
      params: httpParams,
    });
  }
}
